module.exports = __webpack_public_path__ + "media/Green_winged_Teal.f51b5465.mp3";